import { di } from 'react-magnetic-di';
import { useMessages as useVAMessages } from '@atlassian/help-center-virtual-agent/src/controllers/conversation-store';

import { useProvider } from '@atlassian/unified-help-common/src/store/routing';
import { ConversationProvider } from '@atlassian/unified-help-common/src/types';
import { useConversation as useAIAnswersConversation } from '../../../store/converse';

export const useHasMessages = () => {
    di(useProvider, useAIAnswersConversation, useVAMessages);

    const provider = useProvider();
    const [AIAnswersConversation] = useAIAnswersConversation();
    const VAMessages = useVAMessages();

    if (provider === ConversationProvider.VIRTUAL_AGENT) {
        return VAMessages.length > 0;
    }

    return !!AIAnswersConversation;
};
